import { FormControl } from "@mui/material";
import { CustomTypography } from "../CustomTypography/CustomTypography";
import useStyles from "./styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/fr";
import { FieldError } from "../FieldError/FieldError";
import {
  DateValidationError,
  PickerChangeHandlerContext,
} from "@mui/x-date-pickers";
type Props = {
  label?: string;
  marginBottom?: string | number;
  /** Accepts a Date, ISO string, Dayjs or null — normalized internally. */
  value?: Date | string | Dayjs | null;
  onChange?: (
    value: Date | null,
    context: PickerChangeHandlerContext<DateValidationError>
  ) => void;
  /** Inline validation message shown under the field. */
  helperTextError?: string;
};

/**
 * The Dayjs adapter crashes with "e.isBefore is not a function" when it
 * receives a native Date or a raw string, so every incoming value is
 * normalized to a valid Dayjs instance (or null) before reaching the picker.
 */
const toDayjs = (value: Props["value"]): Dayjs | null => {
  if (value === null || value === undefined || value === "") return null;
  if (dayjs.isDayjs(value)) return value.isValid() ? value : null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

export const CustomTextDatePicker: React.FC<Props> = ({
  label,
  marginBottom,
  value,
  helperTextError,
  onChange,
}) => {
  const classes = useStyles({ marginBottom });

  return (
    <div className={classes.container}>
      {label && (
        <div className={classes.containerLabel}>
          <CustomTypography
            text={label}
            variant={"link"}
            textDecoration={"none"}
          />
        </div>
      )}
      <FormControl className={classes.formControl} variant="outlined">
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
          <DatePicker
            value={toDayjs(value)}
            format="DD/MM/YYYY"
            onChange={(newValue: Dayjs | null, context) =>
              onChange?.(
                newValue && newValue.isValid() ? newValue.toDate() : null,
                context
              )
            }
          />
        </LocalizationProvider>
      </FormControl>
      <FieldError message={helperTextError} />
    </div>
  );
};
